module.exports = __webpack_public_path__ + "static/media/flyer1.8bfcb831.png";